// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"48bc3d2f","845":"a63bfc48"}[chunkId] + ".chunk.js";
};